import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_GL_MASTER_DATA } from "./apiRoutes";

interface UseGetGlMasterDataDropdownProps {
  communityId: string;
  alternateAccount?: boolean;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getGlMasterDataDropdown = async (
  communityId: string,
  alternateAccount?: boolean
) =>
  await axiosAuth.get(
    `${GET_GL_MASTER_DATA}/community/${communityId}/dropdown`,
    {
      params:
        alternateAccount === undefined ? undefined : { alternateAccount },
    }
  );

const useGetGlMasterDataDropdown = ({
  communityId,
  alternateAccount,
  queryParams,
}: UseGetGlMasterDataDropdownProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["gl-master-data-dropdown", communityId, alternateAccount],
    queryFn: () => getGlMasterDataDropdown(communityId, alternateAccount),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetGlMasterDataDropdown;
